<template>
<v-container fill-height style="padding:0px">
    <v-row wrap style="height: 100%;">
        <v-col cols=2 style="padding:0%">
            <!-- <v-card height="101%" elevation="5" outlined> -->
            <v-navigation-drawer class="white" permanent style="padding-left:1vh" height="101vh">
                <v-list-item style="padding-top:1vh">
                    <v-list-item-content>
                        <v-list-item-title class="title">
                            <p class="text-center">
                                <img src="../assets/LinkRoom.jpg" width="100%">
                            </p>
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list>
                    <v-list-item v-for="item in data.menu[data.language]['items']" :key="item.title" link @click="page(item)">
                        <v-list-item-icon>
                            <v-icon color="primary">{{ item.icon }}</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title class="primary--text">{{ item.title }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <template v-slot:append>
                    <v-list>
                        <v-list-item @click="logout">
                            <v-list-item-icon style="padding-left:2vh">
                                <v-icon color="primary">mdi-logout</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title class="primary--text">{{data.menu[data.language]['logout']}}</v-list-item-title>
                            </v-list-item-content>

                        </v-list-item>
                    </v-list>
                </template>
            </v-navigation-drawer>
            <!-- </v-card> -->
        </v-col>
        <v-col cols=10 style="padding:0vh">
            <v-row wrap>
                <v-app-bar style="padding-top:1vh" outlined clipped-right color="white" height="100vh" flat>
                    <!-- {{data.com}} -->
                    <v-toolbar-title style="padding-left:5vh" v-if="data.com <= 1">
                        <v-icon large color="primary">
                            {{data.menu[data.language]['items'][data.com].icon}}
                        </v-icon>

                        <b style="padding-top:10px;padding-left:5px">
                            {{data.menu[data.language]['items'][data.com].title}}
                        </b>

                    </v-toolbar-title>
                    <v-toolbar-title style="padding-left:5vh" v-if="data.com > 1">
                        <v-icon large color="primary">
                            {{data.menu[data.language]['items'][data.com-1].icon}}
                        </v-icon>

                        <b style="padding-top:10px;padding-left:5px">
                            {{data.menu[data.language]['items'][data.com-1].title}}
                        </b>

                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <p style="padding-top:2vh">
                        <v-btn text @click="edit_language('thai')">ไทย</v-btn> | <v-btn text @click="edit_language('eng')">Eng</v-btn>
                    </p>
                    <v-btn outlined color="white">
                        <v-avatar color="primary" size="40">
                            <v-icon dark>
                                mdi-account-circle
                            </v-icon>
                        </v-avatar>
                    </v-btn>
                </v-app-bar>

                <!-- </v-col> -->
                <v-col cols="12" style="height:90vh;background-color: #f4f5fa;">
                    <v-row wrap style="padding-top:2vh">
                        <v-col cols="10" offset-md="1">
                            <Manage_users v-if="data.com === 0" />
                            <Manage_room v-if="data.com === 1" />
                            <Manage_Item v-if="data.com === 2" />
                            <Manage_Booking v-if="data.com === 3" />
                            <Dashboard v-if="data.com === 4" />
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-col>
    </v-row>

</v-container>
</template>

<script>
import Manage_users from '@/components/Manage_users'
import Manage_room from '@/components/Manage_room'
import Manage_Item from '@/components/Manage_Item'
import Manage_Booking from '@/components/Manage_Booking'
import Dashboard from '@/components/Dashboard'

import {
    Data
} from '../models'
import {
    mapState,
    dispatch,
    mapActions,
    store
} from 'vuex'

export default {

    name: 'Home',

    data: () => ({
        menu: null,
    }),

    components: {
        Manage_users,
        Manage_room,
        Manage_Item,
        Manage_Booking,
        Dashboard

    },
    computed: {
        ...mapState('datas', {
            data: 'data'
        }),
        token() {
            return this.$store.state.datas.data.token
        }
    },

    methods: {
        page(item) {
            if (item.com != this.$store.state.datas.data.com) {
                // console.log(this.$store.state.datas.data.menu[this.$store.state.datas.data.language]['items'])
                //     console.log(item.com)
                if (item.com != 5) {
                    this.$store.dispatch("datas/callpage", item.com)
                    this.$store.state.datas.data.showtable = false
                }
                if (item.com == 5) {
                    this.$router.push({
                        name: 'Monitor'

                    });
                }

            }

        },
        logout() {
            this.$store.dispatch("datas/logout")
            this.$router.push({
                name: 'Login'
            });
        },
        edit_language(language) {
            this.$store.state.datas.data.language = language
        }
    },
    created() {
        if (this.$store.state.datas.data.token == null) {
            this.$router.push({
                name: 'Login'
            });
        }
    },
    watch: {
        token() {
            // console.log("namamma")
            if (this.$store.state.datas.data.token == null) {
                this.$router.push({
                    name: 'Login'
                });
            }
        }
    },

}
</script>

<style>
.container {
    max-width: 100%;
}
</style>
